import * as React from 'react'
import {
  MissionSectionCol,
  MissionSectionContainer, MissionSectionEmptyCol,
  MissionSectionText,
  MissionSectionTitle
} from './MissionSection.elements'

type Props = {
  title: string,
  text: string
}

export const MissionSection: React.FunctionComponent<Props> = ({title, text}: Props) => (
  <MissionSectionContainer>
    <MissionSectionCol>
      <MissionSectionTitle>
        {title}
      </MissionSectionTitle>
      <MissionSectionText dangerouslySetInnerHTML={{__html: text}} />
    </MissionSectionCol>
    <MissionSectionEmptyCol />
  </MissionSectionContainer>
)
